module.exports = __webpack_public_path__ + "static/media/a3.e95ad180.png";